function itemHtml(ctx, it) {
    return `<article class="fq-entry" data-text="${it.searchText}"><span class="fq-num" aria-hidden="true">${it.num}</span><div><h3 class="fq-q">${it.q}</h3><div class="fq-a">${it.aHtml}</div></div></article>`;
}
const bulletin = {
    id: 'bulletin',
    name: 'Bulletin',
    tag: 'Searchable answer board',
    styleTag: 'Clear & practical',
    description: 'A tinted search masthead and numbered, always-open answers. Filter questions and answer text instantly, without opening each result \u2014 useful for detailed product FAQs.',
    layout: 'list',
    defaultAccent: '#5262b5',
    darkDefault: false,
    catSupport: 'none',
    features: ['search'],
    render(ctx) {
        return {
            html: `<div class="fq-wrap"><div class="fq-head"><h2 class="fq-title">${ctx.title}</h2>${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}<div class="fq-search">${ctx.svg.search}<input class="fq-searchbox" type="search" placeholder="${ctx.t('search')}" aria-label="${ctx.t('search')}"></div></div><div class="fq-list">${ctx.items.map((it) => itemHtml(ctx, it)).join('')}<p class="fq-empty" role="status" hidden>${ctx.t('noResults')}</p></div></div>`,
            css: `
.FQM .fq-wrap{max-width:780px;margin:0 auto;border:1px solid ${ctx.v.border};border-radius:${ctx.v.radiusWrap};overflow:hidden;overflow-wrap:anywhere;background:${ctx.v.card}}
.FQM .fq-head{padding:30px;background:${ctx.v.soft};border-bottom:1px solid ${ctx.v.border}}
.FQM .fq-title{margin:0 0 10px;font-family:${ctx.v.head};font-size:34px;line-height:1.15;font-weight:650;letter-spacing:-.02em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:15px;line-height:1.65;color:${ctx.v.sub}}
.FQM .fq-search{display:flex;align-items:center;gap:12px;margin-top:22px;padding:14px 16px;border:1px solid ${ctx.v.border};border-radius:${ctx.v.radius};background:${ctx.v.card};color:${ctx.v.accent}}
.FQM .fq-searchbox{width:100%;min-width:0;border:0;background:transparent;font:inherit;font-size:15px;color:${ctx.v.ink}}
.FQM .fq-searchbox::placeholder{color:${ctx.v.sub}}
.FQM .fq-entry{display:grid;grid-template-columns:30px minmax(0,1fr);gap:16px;padding:26px 30px;border-bottom:1px solid ${ctx.v.border}}
.FQM .fq-entry:last-of-type{border-bottom:0}
.FQM .fq-num{padding-top:3px;font-family:${ctx.v.mono};font-size:12px;color:${ctx.v.accent}}
.FQM .fq-q{margin:0 0 10px;font-size:17px;font-weight:650;line-height:1.45;color:${ctx.v.ink}}
.FQM .fq-a{font-size:15px;line-height:1.75;color:${ctx.v.sub}}
.FQM .fq-empty{margin:0;padding:30px;color:${ctx.v.sub};font-size:15px}
@media(max-width:480px){.FQM .fq-head{padding:22px 18px}.FQM .fq-entry{padding:22px 18px;gap:10px;grid-template-columns:24px minmax(0,1fr)}}
`,
        };
    },
};
export default bulletin;
